import React from 'react';
import { Stack, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ColumnCard from './ColumnCard';

const ColumnsTab = ({
  columns,
  columnErrors,
  labelColor,
  switchSx,
  accentColor,
  onFieldChange,
  onSwitchChange,
  onAddColumn,
  onRemoveColumn
}) => (
  <Stack spacing={3}>
    {columns.map((column, index) => (
      <ColumnCard
        key={(column.column_id || column.column_name || 'column') + '-' + index}
        column={column}
        index={index}
        error={columnErrors?.[index]}
        labelColor={labelColor}
        switchSx={switchSx}
        onFieldChange={onFieldChange}
        onSwitchChange={onSwitchChange}
        onRemove={onRemoveColumn}
      />
    ))}
    <Button
      variant="outlined"
      startIcon={<AddIcon />}
      onClick={onAddColumn}
      sx={{ alignSelf: 'flex-start', borderColor: accentColor, color: accentColor }}
    >
      Agregar columna
    </Button>
  </Stack>
);

export default ColumnsTab;
